import { format } from "date-fns";

export interface Column {
  id: 'sessaoEscolhida' | 'dataHoraSessao' | 'instituicao' | 'serie' | 'alunos' | 'professor';
  label: string;
  minWidth?: number;
  maxWidth?: number;
  align?: 'right' | 'center' | 'left';
  format?: (value: string|number) => string;
}

export const columns: readonly Column[] = [
  { id: 'dataHoraSessao', label: 'Data e hora', minWidth: 150 , format: (value:string|number) => format(new Date(value),"dd/MM/yyyy HH'h'mm")},
  { id: 'sessaoEscolhida', label: 'Sessão Escolhida', minWidth: 120, align: 'center'},
  { id: 'instituicao', label: 'Instituição', minWidth: 100, maxWidth:100, align: 'center'},
  { id: 'serie', label: 'Série/Ano', minWidth: 170, align: 'center' },
  { id: 'alunos', label: 'Nº de participantes', minWidth: 100, align: 'center' },
  { id: 'professor', label: 'Professor(a)', minWidth: 170, align: 'center' },
];